import { createContext, useContext, useEffect, useMemo, useState } from 'react';

type Label = string;
type Path = string;
type OnClick = (path?: string) => void;
type Crumb = [Label, Path?, OnClick?];

export interface BreadcrumbContextProps {
  crumbs: Crumb[];
  setCrumbs: (crumbs: Crumb[]) => void;
}

const defaultContext: BreadcrumbContextProps = {
  crumbs: [],
  setCrumbs: () => {},
};

const BreadcrumbContext = createContext(defaultContext);

export function BreadcrumbProvider({ children }: { children: JSX.Element }) {
  const [crumbs, setCrumbs] = useState<Crumb[]>([]);

  const value = useMemo(
    () => ({
      crumbs,
      setCrumbs,
    }),
    [crumbs]
  );

  return (
    <BreadcrumbContext.Provider value={value}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbs() {
  const { crumbs, setCrumbs } = useContext(BreadcrumbContext);

  return [crumbs, setCrumbs] as const;
}

export function useSetBreadcrumbs(crumbs: Crumb[]) {
  const { setCrumbs } = useContext(BreadcrumbContext);

  useEffect(() => {
    setCrumbs(crumbs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
